<template>
  <div
    v-if="Object.values(entities.internetAuctions).length"
  >
    <transition
      mode="out-in"
      name="fade"
    >
      <div
        class="row internet_auction-list"
        v-if="!internetGridView"
        key="list"
      >
        <ArtworkRow
          v-for="internetAuction in entities.internetAuctions"
          :internetAuction="internetAuction"
          :key="internetAuction.id"
        />
      </div>
      <div
        class="row internet_auction-grid grid-view"
        key="grid"
        v-else
      >
        <ArtworkRow
          v-for="internetAuction in entities.internetAuctions"
          :internetAuction="internetAuction"
          :key="internetAuction.id"
        />
      </div>
    </transition>
    <transition
      @beforeEnter="beforeEnterAnimation"
      @enter="enterAnimation"
      @leave="leaveAnimation"
      appear
    >
      <AuctionModal
         v-if="activeModalAuctionId"
        :internetAuction="entities.internetAuctions[activeModalAuctionId]"
      />
    </transition>
    <div class="employee__filtration">
      <PaginationComponent
        :meta="meta"
        scrollPageToUp
      />
    </div>
  </div>
  <EmptyState
    v-else
    :state-info="I18n.t('auctions_catalogs.lack_of_auctions')"
  />
</template>

<script>
  /* eslint no-param-reassign: ["error", { "props": false }] */
  import { mapState, mapMutations } from 'vuex';
  import IsIos from '@/shared/mixins/is_ios';
  import UrlModification from '@/shared/mixins/url_modification';
  import EmptyState from '@/shared/components/empty_state';
  import PaginationComponent from '@/shared/components/pagination/index';
  import { INTERNET_AUCTIONS_PAGE_PARAMS } from '@/internet_auctions/consts';
  import ArtworkRow from './artwork/row';
  import AuctionModal from './modal';

  export default {
    name: 'Artworks',
    components: {
      ArtworkRow,
      AuctionModal,
      EmptyState,
      PaginationComponent,
    },
    mixins: [IsIos, UrlModification],
    computed: {
      ...mapState([
        'activeModalAuctionId',
        'internetGridView',
        'entities',
        'userLimits',
        'meta',
      ]),
    },
    methods: {
      ...mapMutations([
        'SET_ACTIVE_MODAL_AUCTION_ID',
        'SET_SEARCH_QUERY',
      ]),
      setBodyClass() {
        if (this.isIos) {
          document.body.classList.add('ios-fix');
        } else {
          document.body.classList.add('modal-open');
        }
      },
      beforeEnterAnimation(el) {
        this.setBodyClass();
        el.style.transform = 'translateY(-40%)';
        el.style.opacity = '0';
      },
      enterAnimation(el, done) {
        let round = -40;
        el.style.opacity = 1;

        const interval = setInterval(() => {
          el.style.transform = `translateY(${round}%)`;
          round += 1;
          if (round > 0) {
            clearInterval(interval);
            el.style.transform = '';
            done();
          }
        }, 3);
      },
      leaveAnimation(el, done) {
        let round = 0;
        let opacityProperty = 1;

        const interval = setInterval(() => {
          el.style.transform = `translateY(${round}%)`;
          el.style.opacity = opacityProperty;
          round -= 1;
          opacityProperty -= 0.025;
          if (round < -50) {
            clearInterval(interval);
            document.body.className = '';
            done();
          }
        }, 3);
      },
      showAuctionModal() {
        const internetAuctions = this.entities.internetAuctions;
        const auctionKey = Object.keys(internetAuctions)[0];
        const artworkName = internetAuctions[auctionKey].artwork.name;

        this.openModal(auctionKey);
        this.setQuery(artworkName);
      },
      openModal(id) {
        this.SET_ACTIVE_MODAL_AUCTION_ID(id);
      },
      setQuery(query) {
        this.SET_SEARCH_QUERY(query.toLowerCase());
        this.updateUrl(INTERNET_AUCTIONS_PAGE_PARAMS.searchQuery, query);
      },
    },
    mounted() {
      if (typeof this.$route.query.artwork_id !== 'undefined') this.showAuctionModal();
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/artworks.vue?e2ea60f0